import { useTranslation } from 'react-i18next';
import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import ListItem from '@mui/material/ListItem';

import { provideFlagIcon } from './IconProvider';
import './LanguageSelector.css';
import { Language, getAvailableLanguages } from './translateFunctions';
import { Typography } from '@mui/material';

const LanguageItem = ({ language }: { language: Language }) => {
  const { t, i18n } = useTranslation();

  async function languageChange() {
    await i18n.changeLanguage(language.code);
    localStorage.setItem('language', language.code);
  }

  return (
    <ListItem
      disablePadding
      className="language-selector-list-item"
      onClick={languageChange}
      data-qa-element-id={`language-selector-language-${language.code}`}
    >
      <Stack direction="row">
        <img className="language-selector-list-icon" src={provideFlagIcon(language.code)} />
        <Typography
          variant="body2"
          className={
            language.code === i18n.language
              ? 'language-selector-list-item-selected-main'
              : 'language-selector-list-item-nonselected'
          }
        >
          {t(language.name)}
        </Typography>
      </Stack>
    </ListItem>
  );
};

const LanguageSelector = () => {
  const availableLanguages: Language[] = getAvailableLanguages();

  return (
    <List component={Stack} direction="row" className="language-selector-list-login">
      {availableLanguages.map((lang) => (
        <LanguageItem language={lang} key={lang.code} data-qa-element-id={`language-selector-language-${lang.code}`} />
      ))}
    </List>
  );
};

export default LanguageSelector;
